<template>
    <div class="hello" ref="chartdiv">
    </div>
</template>

<script>
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    am4core.useTheme(am4themes_animated);


    export default {
        name: 'amchart-xy',
        props: {
            data: Array,
            categoryAxis: Object,
            valueAxis: Object,
            series: Object
        },
        computed: {},
        mounted() {

            let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart)

            // Add Data
            chart.data = this.data

            // Add category axis
            if(this.categoryAxis !== null && typeof(this.categoryAxis) !== 'undefined'){
                chart.xAxes.push(this.categoryAxis)
            } else {
                chart.xAxes.push(new am4charts.CategoryAxis())
            }


            // Add value axis
            if(this.valueAxis !== null && typeof(this.valueAxis) !== 'undefined'){
                chart.yAxes.push(this.valueAxis)
            } else {
                chart.yAxes.push(new am4charts.ValueAxis())
            }

            // Add series
            if(this.series !== null && typeof(this.series) !== 'undefined'){
                chart.series.push(this.series)
            } else {
                chart.series.push(new am4charts.ColumnSeries())
            }

        },

        beforeDestroy() {
            if (this.chart) {
                this.chart.dispose();
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .hello {
        width: 100%;
        height: 500px;
    }
</style>



// WEBPACK FOOTER //
// src/components/amcharts/amchart-xy.vue